import React from 'react';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import { Table } from 'apps/sigma2-ui/src/components/ui/Table';
import { DataSetEditPostgresIntegrationHook } from 'apps/sigma2-ui/src/data-wizard/lib/useDataSetEditPostgresIntegration';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

export const DataSetPostgresConfigurationTableListComponent = ({
  postgresIntegrationHook,
}: {
  postgresIntegrationHook: DataSetEditPostgresIntegrationHook;
}) => {
  const language = useLanguage();

  return (
    <>
      <S2Typography
        variant={'headline-3'}
        translatedContent={language.tableList()}
      />
      <Button
        behavior={{
          type: 'onClick',
          onClick: () => {
            postgresIntegrationHook.setPostgresIntegration({
              ...postgresIntegrationHook.postgresIntegration,
              tables: [
                ...postgresIntegrationHook.postgresIntegration.tables,
                {
                  tableName: '',
                },
              ],
            });
          },
        }}
        text={'Add Table'}
      />
      <Table
        items={postgresIntegrationHook.postgresIntegration.tables}
        columnDefinitions={[
          {
            id: 'tableName',
            header: () => <div>Table Name</div>,
            cell: ({ item, rowIndex }) => (
              <input
                className="form-input"
                type="text"
                key={'url'}
                value={item.tableName}
                aria-label={'table name'}
                onChange={(event) => {
                  const newTableList = [
                    ...postgresIntegrationHook.postgresIntegration.tables,
                  ];
                  newTableList[rowIndex] = {
                    ...newTableList[rowIndex],
                    tableName: event.target.value,
                  };
                  postgresIntegrationHook.setPostgresIntegration({
                    ...postgresIntegrationHook.postgresIntegration,
                    tables: newTableList,
                  });
                }}
              />
            ),
          },
          {
            id: 'tableName',
            header: () => <div>Schema Name</div>,
            cell: ({ item, rowIndex }) => (
              <input
                className="form-input"
                type="text"
                key={'url'}
                value={item.schema ?? ''}
                aria-label={'schema name'}
                onChange={(event) => {
                  const newTableList = [
                    ...postgresIntegrationHook.postgresIntegration.tables,
                  ];
                  newTableList[rowIndex] = {
                    ...newTableList[rowIndex],
                    schema: event.target.value,
                  };
                  postgresIntegrationHook.setPostgresIntegration({
                    ...postgresIntegrationHook.postgresIntegration,
                    tables: newTableList,
                  });
                }}
              />
            ),
          },
          {
            id: 'actions',
            header: () => <div>Actions</div>,
            cell: ({ rowIndex }) => (
              <Button
                behavior={{
                  type: 'onClick',
                  onClick: () => {
                    const newTableList = [
                      ...postgresIntegrationHook.postgresIntegration.tables,
                    ];
                    newTableList.splice(rowIndex, 1);
                    postgresIntegrationHook.setPostgresIntegration({
                      ...postgresIntegrationHook.postgresIntegration,
                      tables: newTableList,
                    });
                  },
                }}
                text={'Remove'}
              />
            ),
          },
        ]}
      />
    </>
  );
};
